import { UrlUtils } from '@wix/package-picker-shared';
const URL = '/_api/premium-store/v1/ValidateNoPreviousPurchase';
export const checkDoublePurchaseQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    productTypeId,
    siteGuid
  } = request;
  const response = await httpClient.post(UrlUtils.buildUrl({
    url: URL,
    params: {
      productTypeId,
      msid: siteGuid
    }
  }));
  return response.data;
};
//# sourceMappingURL=checkDoublePurchase.query.js.map